module.exports = __webpack_public_path__ + "static/img/2026.8da1793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2026.jpg
// module id = 316
// module chunks = 0